module.exports = __webpack_public_path__ + "img/SV.87a195b6.svg";